<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="divContainer">
          <div class="col col-12 col-sm-12">
            <div id="exTab2">
              <ul class="nav nav-tabs nav-tabs-custom">
                <li data-tabname="Dashboard">
                  <a href="#tabDashboard" class="nav-link active" data-toggle="tab" name="Dashboard" (click)="GetInboxList('Dashboard')">Dashboard</a>
                </li>
                <li data-tabname="Inbox">
                  <a href="#tabInbox" class="nav-link" data-toggle="tab" name="Inbox" (click)="GetInboxList('Inbox')">Inbox</a>
                </li>
              </ul>

              <div class="tab-content">

                <div id="tabDashboard" class="tab-pane active">
                  <div class="row" id="divSummaryIndex">
                    <div class="col-12 col-sm-6 col-md-3">
                      <div class="info-box">
                        <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>
                        <div class="info-box-content">
                          <span class="info-box-text">Due Today</span>
                          <span class="info-box-number">{{TodayDueCt}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-3">
                      <div class="info-box mb-3">
                        <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-book"></i></span>
                        <div class="info-box-content">
                          <span class="info-box-text">File Pending</span>
                          <span class="info-box-number">{{FilePendingCt}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-3">
                      <div class="info-box mb-3">
                        <span class="info-box-icon bg-success elevation-1"><i class="fa fa-download"></i></span>
                        <div class="info-box-content">
                          <span class="info-box-text">File Download</span>
                          <span class="info-box-number">{{FileDownloadCt}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-3">
                      <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="fa fa-upload"></i></span>
                        <div class="info-box-content">
                          <span class="info-box-text">Total Uploaded</span>
                          <span class="info-box-number">{{FileUploadCt}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <highcharts-chart [Highcharts]="highchartsArea"
                                    [options]="chartOptionsArea"
                                    style="width: 100%; height: 400px; display: block;">
                  </highcharts-chart>
                </div>

                <div id="tabInbox" class="tab-pane">

                  <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>

                  <div class="col-sm-12" id="divMainFilter">
                    <div class="row">
                      <div class="col-sm-8">
                        <label>Journals</label>
                        <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                          <option *ngFor="let item of journalList" value={{item.ID}}>
                            {{item.Acronym}}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-2">
                        <label>Volume</label>
                        <select id="lstVolume" class="form-control">
                          <option selected value="0">All</option>
                          <option *ngFor="let item of volumeList" value={{item.ID}}>
                            {{item.Volume}}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-2">
                        <label>Issue</label>
                        <select id="lstIssue" class="form-control">
                          <option selected value="0">All</option>
                          <option *ngFor="let item of issueList" value={{item.ID}}>
                            {{item.Issue}}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-2">
                        <label>From</label>
                        <input id="Txt_FromDate" type="Date" class="form-control" autocomplete="off">
                      </div>
                      <div class="col-sm-2">
                        <label>To</label>
                        <input id="Txt_ToDate" type="Date" class="form-control" autocomplete="off">
                      </div>
                      <div class="col-sm-3">
                        <label>Status</label>
                        <select id="ddlUploadStatus" class="form-select">
                          <option value="All" selected>All</option>
                          <option value="Uploaded">Upload: Success</option>
                          <option value="Failed">Upload: Fail</option>
                          <option value="Waiting">Waiting for Vendor File Upload</option>
                          <option value="UploadFail">File Failed to Send to Vendor</option>
                        </select>
                      </div>

                      <div class="col-sm-2">
                        <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" id="btnLoadList" title="Get" (click)="GetInboxList('Inbox')">Search</button>
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div id="divDataListTab">

                    <button type="button" id="btnPopupDT" (click)="VendorInfo('Info')" style="display:none">VendorInfo</button>
                    <button type="button" id="btnDownloadDT" (click)="Download()" style="display:none">Download</button>
                    <button type="button" id="btnUploadDT" (click)="VendorInfo('Upload')" style="display:none">Upload</button>
                    <button type="button" id="btnHideTrigger" (click)="hide()" style="display:none">Hide</button>

                    <table #dataTable class="display" style="width:100%"></table>

                    <app-articlemeta></app-articlemeta>


                  </div>

                  <div id="divFileUpload" class="modal">
                    <div class="modal-dialog modal-md">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h3 class="modal-title">Upload Package?</h3>
                          <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
                        </div>
                        <div class="modal-body">
                          <form id="frmFiles">
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <h5>
                                    Choose File(s) for this package:
                                    <br />
                                    <span id="lblPkgList">
                                      {{PopupTitle}}
                                    </span>
                                  </h5>
                                  <!--<app-upload></app-upload>-->
                                  <div class="col-md-12" style="text-align:center">
                                    <input type="file" #file placeholder="Choose file" multiple (change)="uploadFile(file.files)" style="display:none;" />
                                    <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnUploadFile" (click)="file.click()">Upload File</button>
                                  </div>
                                  <div class="col-md-12">
                                    <span class="upload" id="spanProgress" *ngIf="progress > 0">
                                      {{progress}}%
                                    </span>
                                    <span class="upload" id="spanUploadMsg" *ngIf="message">
                                      {{message}}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div id="LoadingImagePopup">
                      <img src="../../assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                    </div>
                  </div>

                  <div id="divLogInfo" class="modal">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content" id="modal_contentArt">
                        <div class="modal-header">
                          <h4 class="modal-title">Package - {{PopupTitle}}</h4>
                          <button type="button" class="close" data-dismiss="modal" onclick="$('.modal').hide()">×</button>
                        </div>
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-sm-12">
                              <table class="tblVendorInfo">
                                <tbody>
                                  <tr>
                                    <td colspan="2" class="clsHeader">Tracking details</td>
                                  </tr>
                                  <tr><td>Allocate Date</td><td>{{this.LogItem.AllocateDate}}</td></tr>
                                  <tr><td>Due Date</td><td>{{this.LogItem.DueDate}}</td></tr>
                                  <tr><td>Upload Date</td><td>{{this.LogItem.UploadDate}}</td></tr>
                                  <tr><td>Upload Package Name</td><td>{{this.LogItem.UploadPackage}}</td></tr>
                                  <tr><td>Upload Status</td><td>{{this.LogItem.UploadStatus}}</td></tr>
                                  <tr>
                                    <td>Package Validation Status</td>
                                    <td>
                                      {{this.LogItem.ValidateStatus}}
                                      <span *ngIf="this.LogItem.FailureLogFile != null"
                                            class="spdownload"
                                            title="Download Error log" (click)="DownloadErrorLog()">
                                        {{this.LogItem.FailureLogFile}}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Failure Remarks</td>
                                    <td>
                                      <div innerHTML="{{this.LogItem.Remarks}}" style="overflow:auto;" id="divFailLog">
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" onclick="$('.modal').hide()">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
